import React from "react";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export const DynamicCheckboxComp4 = ({ label, isChecked }) => {
  return (
    <Grid item xs={12} sm={6} md={4} className="m-b-10">
      <p className="tFormlabel checkAndTextAlign">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox disabled checked={isChecked} />}
            label={label}
          />
        </FormGroup>
      </p>
    </Grid>
  );
};
export const DynamicCheckboxComp6 = ({ label, isChecked }) => {
  return (
    <Grid item xs={12} sm={6} md={4} className="m-b-10">
      <p className="tFormlabel checkAndTextAlign">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox disabled checked={isChecked} />}
            label={label}
          />
        </FormGroup>
      </p>
    </Grid>
  );
};
export const DynamicCheckboxComp126 = ({ label, isChecked }) => {
  return (
    <Grid item xs={12} sm={6} className="m-b-10">
      <p className="tFormlabel checkAndTextAlign">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox disabled checked={isChecked} />}
            label={label}
          />
        </FormGroup>
      </p>
    </Grid>
  );
};

export const DynamicCheckboxComp12 = ({ label, isChecked }) => {
  return (
    <Grid item xs={12} sm={12} md={12} className="m-b-10">
      <p className="tFormlabel checkAndTextAlign">
        <FormGroup>
          <FormControlLabel
            control={<Checkbox disabled checked={isChecked} />}
            label={label}
          />
        </FormGroup>
      </p>
    </Grid>
  );
};
